<template>
  <div class="group-info-container">
    <van-nav-bar title="推广组信息" left-text="" left-arrow @click-left="onClickLeft" @click-right="onClickRight" :style="{ backgroundColor: '#1a1a1a', color: '#ffffff' }" :title-style="{ color: '#ffffff' }" :left-arrow-style="{ color: '#ffffff' }" />
    <div class="info-content" v-if="info">
      <div class="info-item">
        <div class="info-label">推广组名称</div>
        <div class="info-value">
          <van-field v-model="name" type="text" readonly />
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">收益组长分成</div>
        <div class="info-value">
          <van-field v-model="leaderRatio" type="text" readonly />
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">收益上级分成</div>
        <div class="info-value">
          <van-field v-model="memberRatio" type="text" readonly />
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">充值组长分成</div>
        <div class="info-value">
          <van-field v-model="memberPayOwnerRatio" type="text" readonly />
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">充值上级分成</div>
        <div class="info-value">
          <van-field v-model="chargeIncomeRatio" type="text" readonly />
        </div>
      </div>
      <div class="info-item" v-if="memberIncomeRatio">
        <div class="info-label">聊天分成</div>
        <div class="info-value">
          <van-field v-model="memberIncomeRatio" type="text" readonly />
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">结算周期</div>
        <div class="info-value">
          <van-field v-model="period" type="text" readonly />
        </div>
      </div>
      <div class="info-item clickable-item" @click="onMemberNumTapped">
        <div class="info-label">成员数</div>
        <div class="info-value with-arrow">
          <van-field v-model="memberNum" type="text" readonly />
          <span class="arrow-icon">
            <van-icon name="arrow" size="16" color="#999" />
          </span>
        </div>
      </div>
      <div class="info-item">
        <div class="info-label">创建时间</div>
        <div class="info-value">
          <van-field v-model="createTime" type="text" readonly />
        </div>
      </div>
    </div>
    
    <div class="action-buttons" v-if="false">
      <van-button class="action-btn comission-btn" type="primary" round size="large" @click="onCommissionTapped">
        分成统计
      </van-button>
      <van-button class="action-btn income-btn" type="primary" round size="large" @click="onIncomeTapped"
        :text="info.type === 0 ? '收益流水' : '充值流水'" />
    </div>
    
    <Mask v-if="marke"></Mask>
  </div>
</template>
<script>
// import { wxqq } from '../utils/utils'
import Mask from '../components/Mask'
import routerUtil from '../utils/routerUtil'
import { Toast } from "vant"

export default {
  name: 'GroupInfo',
  data() {
    return {
      info: null,
      marke: false,
    }
  },
  computed: {
    name() {
      if (this.info) {
        return this.info.name;
      }
      return ""
    },
    leaderRatio() {
      if (this.info) {
        // 保留0位小数
        return Math.round(this.info.ownerRatio * 100) + "%";
      }
      return ""
    },
    memberRatio() {
      if (this.info) {
        // 保留0位小数
        return Math.round(this.info.memberRatio * 100) + "%";
      }
      return ""
    },

    memberPayOwnerRatio(){
      if (this.info) {
        // 保留0位小数
        return Math.round(this.info.memberPayOwnerRatio * 100) + "%";
      }
      return ""
    },

    chargeIncomeRatio(){
      if (this.info) {
        // 保留0位小数
        return Math.round(this.info.chargeIncomeRatio * 100) + "%";
      }
      return ""
    },

    memberIncomeRatio() {
      if (this.info && this.info.type === 0) {
        if (this.info.memberIncomeRatio) {
          // 保留0位小数
          return '消息' + Math.round(this.info.memberIncomeRatio.message * 100) + '%，礼物' + Math.round(this.info.memberIncomeRatio.gift * 100) + '%，通话' + Math.round(this.info.memberIncomeRatio.call * 100) + '%'
        }
        return ''
      }
      return null
    },
    period() {
      if (this.info) {
        switch (this.info.period) {
          case 1:
            return "日";
          case 2:
            return "周";
          case 3:
            return "月";
        }
      }
      return ""
    },
    memberNum() {
      if (this.info) {
        return this.info.memberCount;
      }
      return ""
    },
    createTime() {
      if (this.info) {
        const date = new Date(this.info.createTime);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const min = date.getMinutes();
        const sec = date.getSeconds();
        return `${date.getFullYear()}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
      }
      return ""
    }
  },
  components: {
    Mask,
  },
  mounted() {
    // this.marke = wxqq()
    this.reqInfo();
  },
  methods: {
    onClickLeft() {
      routerUtil.back()
    },
    onClickRight() {
    },
    reqInfo() {
      this.$request.postJson('/api/user/pay_group/info', {})
        .then((res) => {
          if (res.data.code == 0) {
            this.info = res.data.data;
            if (!this.info) {
              Toast('暂无推广组信息');
              routerUtil.back()
              return;
            }
          }
        });
    },
    onMemberNumTapped() {
      this.$router.push({ path: 'MemberList' });
    },
    onCommissionTapped() {
      this.$router.push({ path: 'Comission' });
    },
    onIncomeTapped() {
      this.$router.push({ path: 'Income' });
    }
  },
}
</script>
<style scoped lang="less">
// 全局样式重置
.group-info-container {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  font-size: 14px;
  color: #e0e0e0;
  padding-bottom: 100px; // 为底部按钮留出空间
}

// 信息内容区域
.info-content {
  background: #2a2a2a;
  border-radius: 12px;
  margin: 16px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  border: 1px solid #3a3a3a;
}

// 信息项样式
.info-item {
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid #3a3a3a;
  transition: all 0.3s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &.clickable-item {
    cursor: pointer;
    
    &:hover {
      background-color: rgba(255, 255, 255, 0.05);
    }
  }
}

// 标签样式
.info-label {
  width: 30%;
  font-weight: 500;
  color: #ffffff;
  font-size: 14px;
}

// 值样式
.info-value {
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #e0e0e0;
  font-size: 14px;
  
  &.with-arrow {
    position: relative;
  }
}

// 箭头图标
.arrow-icon {
  margin-left: 8px;
  display: flex;
  align-items: center;
}

// 自定义Vant组件样式
:deep(.van-field) {
  background: transparent !important;
  border: none !important;
  height: auto !important;
  padding: 0 !important;
  width: 100%;
  
  &__control {
    font-size: 14px !important;
    color: #e0e0e0 !important;
    padding: 0 !important;
    text-align: right;
    background: transparent !important;
    border: none !important;
    
    &::placeholder {
      color: #909090 !important;
      font-size: 14px !important;
    }
  }
  
  &__left-icon,
  &__right-icon {
    display: none;
  }
}

// 导航栏样式
:deep(.van-nav-bar) {
  background-color: #1a1a1a;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  &__title {
    color: #ffffff;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  &__left {
    color: #ffffff;
    
    .van-icon {
      color: #ffffff !important;
    }
  }
}

// 底部按钮区域
.action-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  background-color: #1a1a1a;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  gap: 12px;
  box-sizing: border-box;
}

// 按钮样式
.action-btn {
  flex: 1;
  height: 44px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  
  &:active {
    transform: translateY(1px);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  }
}

// 按钮颜色
.comission-btn {
  background-color: #333333;
  color: #ffffff;
  border: 1px solid #4a4a4a;
}

.income-btn {
  background-color: #444444;
  color: #ffffff;
  border: 1px solid #5a5a5a;
}

// 响应式设计
@media (max-width: 768px) {
  .info-content {
    margin: 12px;
    padding: 12px;
  }
  
  .info-item {
    padding: 12px 0;
  }
  
  .info-label {
    width: 35%;
    font-size: 13px;
  }
  
  .info-value {
    width: 65%;
    font-size: 13px;
  }
  
  .action-buttons {
    padding: 12px;
  }
  
  .action-btn {
    height: 40px;
    font-size: 15px;
  }
}
// 自定义Vant组件样式
:deep(.van-field) {
  background: transparent !important;
  border: none !important;
  height: auto !important;
  padding: 0 !important;
  width: 100%;
  
  // 1. 隐藏输入框的下划线（核心修复）
  &::after {
    display: none !important;
  }
  
  &__control {
    font-size: 14px !important;
    color: #e0e0e0 !important;
    padding: 0 !important;
    text-align: right;
    background: transparent !important;
    border: none !important;
    
    &::placeholder {
      color: #909090 !important;
      font-size: 14px !important;
    }
    
    // 2. 保险起见，也隐藏控制框的下划线
    &::after {
      display: none !important;
    }
  }
  
  &__left-icon,
  &__right-icon {
    display: none;
  }
}
</style>
    